import { useApolloClient } from "@apollo/client";
import React from "react";
import type { ModifyItemInfoValuesInput } from "../../../../clients/graphqlTypes.js";
import { useHeaderBox_ModifyItemInfoMutation } from "../../doc-items/boxes/HeaderBox.generated.js";

interface Options {
  projectId: string | null;
  docId: string;
}

export type ModifyItemInfoFn = (
  itemId: string,
  values: Partial<ModifyItemInfoValuesInput>
) => Promise<void>;

export function useModifyItemInfo({ projectId, docId }: Options) {
  const client = useApolloClient();
  const [modifyItemInfoMutation] = useHeaderBox_ModifyItemInfoMutation({
    client,
  });

  const modifyItemInfo: ModifyItemInfoFn = React.useCallback(
    async (itemId: string, values: Partial<ModifyItemInfoValuesInput>) => {
      const result = await modifyItemInfoMutation({
        variables: {
          input: {
            projectId,
            docId,
            itemId,
            values,
          },
        },
      });
      if (result.errors?.length) {
        throw new Error(result.errors[0].message);
      }
      if (!result.data) {
        throw new Error("Could not modify item");
      }
    },
    [modifyItemInfoMutation, projectId, docId]
  );

  return { modifyItemInfo };
}
